import styles from './pursuit.module.css'

/**
 * Shared sort UI for the Command Center views, so every tab sorts the same way
 * — including by REPRESENTATIVE. Owner sorting always runs through
 * `ownerName()` in `makeComparator`, so blanks group as "Unassigned" and sort
 * last in both directions (unassigned is the expected state, not a name).
 *
 * `Th`      — a sortable table header (Worklist, Gaps, Pursuit Stages shape).
 * `SortBar` — a field select + direction toggle for the card/grid views
 *             (Pursuit Board, Just Won, Calendar) that have no header row.
 */

/** Toggle helper: same field flips direction, a new field starts ascending. */
function toggleSort(setSort, field) {
  setSort((s) => (s.field === field ? { field, dir: s.dir === 'asc' ? 'desc' : 'asc' } : { field, dir: 'asc' }))
}

export function Th({ field, label, sort, setSort, className = '' }) {
  if (!field) return <th className={className}>{label}</th>
  const on = sort.field === field
  return (
    <th
      className={`${styles.sortable} ${on ? styles.sortActive : ''} ${className}`}
      title={`Sort by ${label.toLowerCase()}`}
      aria-sort={on ? (sort.dir === 'asc' ? 'ascending' : 'descending') : 'none'}
    >
      <button type="button" className={styles.sortButton} onClick={() => toggleSort(setSort, field)}>{label}
      <span className={styles.sortArrow}>{on ? (sort.dir === 'asc' ? '▲' : '▼') : '↕'}</span></button>
    </th>
  )
}

export function SortBar({ sort, setSort, fields, label = 'Sort' }) {
  return (
    <div className={styles.sortBar}>
      <span className={styles.sortBarLabel}>{label}</span>
      <select
        className={`input ${styles.sortSel}`}
        value={sort.field}
        onChange={(e) => setSort((s) => ({ ...s, field: e.target.value }))}
      >
        {fields.map((f) => <option key={f.key} value={f.key}>{f.label}</option>)}
      </select>
      <button
        type="button"
        className={styles.sortDir}
        onClick={() => setSort((s) => ({ ...s, dir: s.dir === 'asc' ? 'desc' : 'asc' }))}
        title={sort.dir === 'asc' ? 'Ascending — click for descending' : 'Descending — click for ascending'}
      >
        {sort.dir === 'asc' ? '▲ Asc' : '▼ Desc'}
      </button>
    </div>
  )
}
